// // LEGACY
// class Tabs extends HTMLElement {
//   constructor() {
//     super();
//     this.toggles = [...this.querySelectorAll('[data-toggle]')];
//     this.collapsibles = [...this.querySelectorAll('[data-content]')];
//     this.collapsiblesMobile = [...this.querySelectorAll('[data-tab-menu]')];
//     this.togglesMobile = [...this.querySelectorAll('[data-tab-selector]')];
//     this.titleOption = [...this.querySelectorAll('[data-title-option]')];
//   }

//   connectedCallback() {

//     this.toggles?.forEach((btn) => {
//       const id = btn.dataset.toggle;
//       const collapsible = this.collapsibles.find(({ dataset }) => dataset.content === id);
//       btn.addEventListener('click', () => {
//         this.toggles.forEach((tab)=>{
//             tab.classList.remove('active');
//         })
//         btn.classList.add('active');
//         this.titleOption?.forEach((t) => {
//           t.innerHTML = btn.text;
//         })
//         this.collapsiblesMobile.map(( item ) => {
//           this.toggleMenu(item);
//         });

//         // btn.addEventListener('click', () => {
//         //   this.toggleMenu(collapsible);
//         // });
//         this.collapsibles.filter(({ dataset }) => dataset.content !== id)
//           .forEach((inactiveCollapsible) => {
//             // eslint-disable-next-line no-param-reassign
//             inactiveCollapsible.classList.add('hidden');
//           });
//           collapsible.classList.remove('hidden');
//       });

//     });

//     this.togglesMobile?.forEach((mobileBtn) => {
//       const id = mobileBtn.dataset.tabSelector;
//       mobileBtn.dataset.tabSelector;
//       const collapsible = this.collapsiblesMobile.find(({ dataset }) => dataset.tabMenu === id);

//       mobileBtn.addEventListener('click', () => {
//         this.toggleMenu(collapsible);
//       });
//     });

//     //DEEP LINK
//     let url = window.location.href;
//     if (url.indexOf("#") > 0){

//       const activeTab = url.substring(url.indexOf("#") + 1);
//       const activecollapsible = this.toggles.find(({ dataset }) => dataset.toggle === activeTab.toLowerCase());

//       if(activecollapsible){
//         activecollapsible.click();
//       }
//     }
//   }
//   toggleMenu(collapsible){
//     if(this.togglesMobile.length > 0){
//       collapsible.style.transition = 'height .5s';
//       collapsible.style.height = collapsible.offsetHeight === 0 ? `${collapsible.scrollHeight}px` : '0px';
//     }
//   }
// }
// customElements.define('tab-content', Tabs);

// WORKING
// class Tabs extends HTMLElement {
//   constructor() {
//     super();
//     this.toggles = [...this.querySelectorAll('[data-toggle]')]; // Desktop & Mobile tabs
//     this.collapsibles = [...this.querySelectorAll('[data-content]')]; // Tab content
//     this.collapsiblesMobile = [...this.querySelectorAll('[data-tab-menu]')]; // Mobile collapsibles
//     this.togglesMobile = [...this.querySelectorAll('[data-tab-selector]')]; // Mobile toggle button
//     this.titleOption = [...this.querySelectorAll('[data-title-option]')]; // Mobile tab title
//   }

//   connectedCallback() {
//     this.initializeTabs(); // Initialize tabs behavior
//     this.handleDeepLink(); // Handle deep linking from URL hash
//     window.addEventListener('hashchange', this.loadTabFromHash.bind(this)); // Handle URL hash changes
//   }

//   initializeTabs() {
//     // Set up desktop and mobile toggles
//     this.toggles.forEach((btn) => {
//       const id = btn.dataset.toggle;
//       const collapsible = this.collapsibles.find(({ dataset }) => dataset.content === id);

//       btn.addEventListener('click', () => {
//         this.activateTab(btn, collapsible); // Activate and scroll (if mobile) when clicked
//       });
//     });

//     this.togglesMobile.forEach((mobileBtn) => {
//       const id = mobileBtn.dataset.tabSelector;
//       mobileBtn.addEventListener('click', () => this.toggleMenu(id)); // Mobile dropdown toggle
//     });
//   }

//   activateTab(btn, collapsible) {
//     // Deactivate all tabs and hide all content
//     this.clearActiveStates();
  
//     // Activate the clicked tab
//     btn.classList.add('active');
//     this.titleOption.forEach((t) => (t.innerHTML = btn.textContent)); // Update mobile tab title if applicable
  
//     // Show the corresponding content for the activated tab
//     collapsible.classList.remove('hidden');
//     collapsible.setAttribute('aria-expanded', 'true');
  
//     // Handle mobile-specific behavior (close dropdown and scroll)
//     if (this.isMobile()) {
//       const mobileToggle = btn.closest('.mobile-toggle');
//       const sectionId = mobileToggle ? mobileToggle.getAttribute('data-tab-selector') : null;
  
//       if (sectionId) {
//         console.log("Calling toggleMenu to close with sectionId:", sectionId);
  
//         // Close the dropdown menu only, don't reopen it after
//         this.toggleMenu(sectionId, true); // Force close the dropdown
  
//         // Ensure scrolling happens after the dropdown is closed
//         setTimeout(() => {
//           this.toggleMenu(sectionId, true);
//           this.scrollToContent(collapsible); // Scroll to the tab content
//         }, 300); // Adjust this delay to match your dropdown animation speed (usually ~300ms)
//       } else {
//         console.log("mobileToggle or sectionId not found for the clicked tab."); // Debugging log
//       }
//     }
  
//     // Update the URL hash to reflect the active tab
//     this.updateHash(btn.dataset.toggle);
//   }
  
  
  
//   clearActiveStates() {
//     // Remove active states from all tabs and hide all content
//     this.toggles.forEach((tab) => tab.classList.remove('active'));
//     this.collapsibles.forEach((pane) => {
//       pane.classList.add('hidden');
//       pane.setAttribute('aria-expanded', 'false');
//     });
//   }

//   toggleMenu(sectionId, forceClose = false) {
//     const tabsMenu = document.getElementById(`tabs-menu-${sectionId}`);
    
//     if (tabsMenu) {
//       const isExpanded = tabsMenu.getAttribute('aria-expanded') === 'true';
  
//       console.log("toggleMenu isExpanded:", isExpanded, " forceClose:", forceClose);
  
//       // If forceClose is true, only close the dropdown, don't toggle it open again
//       if (forceClose && isExpanded) {
//         console.log("Closing dropdown...");
//         tabsMenu.setAttribute('aria-expanded', 'false');
//         tabsMenu.style.height = '0px'; // Force close by setting height to 0
//       } else if (!forceClose) {
//         // If we're toggling based on the current state, open or close accordingly
//         if (isExpanded) {
//           console.log("Closing dropdown (normal toggle)...");
//           tabsMenu.setAttribute('aria-expanded', 'false');
//           tabsMenu.style.height = '0px'; // Close
//         } else {
//           console.log("Opening dropdown...");
//           tabsMenu.setAttribute('aria-expanded', 'true');
//           tabsMenu.style.height = `${tabsMenu.scrollHeight}px`; // Open based on content height
//         }
//       }
  
//       console.log("Final state: aria-expanded:", tabsMenu.getAttribute('aria-expanded'), " height:", tabsMenu.style.height);
//     } else {
//       console.log("tabsMenu not found for sectionId:", sectionId);
//     }
//   }
  
  

//   scrollToContent(contentElement) {
//     // Scroll to the content element smoothly
//     const offset = 100; // Adjust the offset based on your layout
//     const contentOffset = contentElement.getBoundingClientRect().top + window.pageYOffset - offset;
//     window.scrollTo({ top: contentOffset, behavior: 'smooth' });
//   }

//   updateHash(tabId) {
//     // Update the URL hash without refreshing the page
//     history.replaceState(null, null, `#${tabId}`);
//   }

//   handleDeepLink() {
//     // Handle the initial URL hash when the page loads
//     if (window.location.hash) {
//       this.loadTabFromHash(); // Load tab from hash without scrolling
//     }
//   }

//   loadTabFromHash() {
//     // Load the correct tab from the hash in the URL
//     const hash = window.location.hash.substring(1);
//     const activeTab = this.toggles.find((tab) => tab.dataset.toggle === hash);

//     if (activeTab) {
//       const collapsible = this.collapsibles.find(({ dataset }) => dataset.content === hash);
//       this.activateTab(activeTab, collapsible); // Activate the tab
//     }
//   }

//   isMobile() {
//     // Check if the view is mobile based on screen width
//     return window.innerWidth <= 850; // Adjust this threshold based on your mobile breakpoint
//   }
// }

// customElements.define('tab-content', Tabs);

// MOST RECENT 
class Tabs extends HTMLElement {
  constructor() {
    super();
    this.toggles = [...this.querySelectorAll('[data-toggle]')]; // Tab buttons
    this.collapsibles = [...this.querySelectorAll('[data-content]')]; // Tab content areas
    this.togglesMobile = [...this.querySelectorAll('[data-tab-selector]')]; // Mobile tab toggle buttons
    this.titleOption = [...this.querySelectorAll('[data-title-option]')]; // Mobile title option text
  }

  connectedCallback() {
    this.initializeTabs(); // Initialize tabs behavior
    this.handleDeepLink(); // Handle deep linking from URL hash
    window.addEventListener('hashchange', this.loadTabFromHash.bind(this)); // Handle URL hash changes
  }

  initializeTabs() {
    // Set up desktop and mobile toggles
    this.toggles.forEach((btn) => {
      const id = btn.dataset.toggle; // The ID of the content this tab controls
      const collapsible = this.collapsibles.find(({ dataset }) => dataset.content === id); // Find the corresponding content

      btn.addEventListener('click', () => {
        this.activateTab(btn, collapsible); // Activate and show the corresponding tab content
      });
    });

    // Set up the click behavior for mobile tab toggles
    this.togglesMobile.forEach((mobileBtn) => {
      const id = mobileBtn.dataset.tabSelector; // The ID of the content this mobile tab controls
      mobileBtn.addEventListener('click', () => this.toggleMenu(id)); // Toggle the mobile dropdown menu
    });
  }

  activateTab(btn, collapsible) {
    // Deactivate all tabs and hide all content
    
    this.clearActiveStates();

    // Activate the clicked tab
    btn.classList.add('active');
    this.titleOption.forEach((t) => (t.innerHTML = btn.textContent)); // Update mobile tab title if applicable

    // Show the corresponding content for the activated tab
    collapsible.classList.remove('hidden');
    collapsible.setAttribute('aria-expanded', 'true');

    // Close the dropdown on mobile
    if (this.isMobile()) {
      const mobileToggle = btn.closest('.mobile-toggle');
      const sectionId = mobileToggle ? mobileToggle.getAttribute('data-tab-selector') : null;

      if (sectionId) {
        
        setTimeout(() => {
          this.toggleMenu(sectionId, true); // Force close the dropdown
          this.scrollToContent(collapsible); // Scroll to the tab content
        }, 300); // Adjust this delay to match your dropdown animation speed (usually ~300ms)
      }
    }

    this.updateHash(btn.dataset.toggle); // Update the URL hash
  }

  clearActiveStates() {
    // Remove active class from all tabs
    this.toggles.forEach((tab) => tab.classList.remove('active'));

    // Hide all content areas and reset their aria-expanded state
    this.collapsibles.forEach((pane) => {
      pane.classList.add('hidden');
      pane.setAttribute('aria-expanded', 'false');
    });
  }

  toggleMenu(sectionId, forceClose = false) {
    const tabsMenu = document.querySelector(`[data-tab-menu="${sectionId}"]`);
    const isExpanded = tabsMenu.getAttribute('aria-expanded') === 'true';

    if (forceClose || isExpanded) {
      tabsMenu.setAttribute('aria-expanded', 'false');
      tabsMenu.style.height = '0px'; // Force close by setting height to 0
    } else {
      tabsMenu.setAttribute('aria-expanded', 'true');
      tabsMenu.style.height = `${tabsMenu.scrollHeight}px`; // Set height dynamically based on content
    }
  }

  isMobile() {
    return window.innerWidth <= 850; // Adjust this threshold based on your mobile breakpoint
  }

  scrollToContent(contentElement) {
    const offset = 100; // Adjust this offset based on your layout
    const contentOffset = contentElement.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: contentOffset, behavior: 'smooth' });
  }

  updateHash(tabId) {
    history.replaceState(null, null, `#${tabId}`);
  }

  handleDeepLink() {
    if (window.location.hash) {
      this.loadTabFromHash();
    }
  }

  loadTabFromHash() {
    const hash = window.location.hash.substring(1);
    const activeTab = this.toggles.find((tab) => tab.dataset.toggle === hash);

    if (activeTab) {
      const collapsible = this.collapsibles.find(({ dataset }) => dataset.content === hash);
      this.activateTab(activeTab, collapsible);
    }
  }
}

customElements.define('tab-content', Tabs);
